
function initializeIngredientsSwipers(scope = document) {
  // Inicializa Swipers para cada grupo de ingredientes
  const groupElements = scope.querySelectorAll('[data-group]');
  groupElements.forEach(groupElement => {
    const groupId = groupElement.getAttribute('data-group');
    const swiperContainer = groupElement.querySelector(`.ingredients-swiper-mobile-${groupId}`);

    if (swiperContainer) {
      const swiperNavigationNext = groupElement.querySelector(`.ingredients-swiper-next-${groupId}`);
      const swiperNavigationPrev = groupElement.querySelector(`.ingredients-swiper-prev-${groupId}`);
      const swiperPagination = groupElement.querySelector(`.ingredients-swiper-pagination-${groupId}`);
      new Swiper(swiperContainer, {
        slidesPerView: 1,
        spaceBetween: 16,
        navigation: {
          nextEl: swiperNavigationNext,
          prevEl: swiperNavigationPrev
        },
        pagination: {
          el: swiperPagination,
          clickable: true
        }
      });
    }
  });

  // Inicializa el Swiper general (sin grupos) si existe
  const generalSwiper = scope.querySelector('.ingredients-swiper-mobile-general');
  if (generalSwiper) {
    const generalNavigationNext = scope.querySelector('.ingredients-swiper-next-general');
    const generalNavigationPrev = scope.querySelector('.ingredients-swiper-prev-general');
    const generalPagination = scope.querySelector('.ingredients-swiper-pagination-general');

    new Swiper(generalSwiper, {
      slidesPerView: 1,
      spaceBetween: 16,
      navigation: {
        nextEl: generalNavigationNext,
        prevEl: generalNavigationPrev
      },
      pagination: {
        el: generalPagination,
        clickable: true
      }
    });
  }
}


function initializeFeaturedDealsSwiper(scope = document) {
  const featuredDealsSwiperContainer = scope.querySelector('.featured-deals__swiper');
  if (featuredDealsSwiperContainer) {
    const featuredDealsNavigationNext = scope.querySelector('.featured-deals__swiper-next');
    const featuredDealsNavigationPrev = scope.querySelector('.featured-deals__swiper-prev');
    const featuredDealsPagination = scope.querySelector('.featured-deals__swiper-pagination');

    new Swiper(featuredDealsSwiperContainer, {
      spaceBetween: 16,
      navigation: {
        nextEl: featuredDealsNavigationNext,
        prevEl: featuredDealsNavigationPrev
      },
      pagination: {
        el: featuredDealsPagination,
        clickable: true
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 20
        },
        640: {
          slidesPerView: 2,
          spaceBetween: 40
        },
        1100: {
          slidesPerView: 4,
          spaceBetween: 40
        }
      }
    });
  }
}

function initializeHowItWorksSwiper(scope = document) {
  const howItWorksSwiperContainer = scope.querySelector('.how-it-works__swiper');
  if (howItWorksSwiperContainer) {
    const howItWorksNavigationNext = scope.querySelector('.how-it-works__swiper-next');
    const howItWorksNavigationPrev = scope.querySelector('.how-it-works__swiper-prev');
    const howItWorksPagination = scope.querySelector('.how-it-works__swiper-pagination');

    new Swiper(howItWorksSwiperContainer, {
      slidesPerView: 1,
      spaceBetween: 16,
      navigation: {
        nextEl: howItWorksNavigationNext,
        prevEl: howItWorksNavigationPrev
      },
      pagination: {
        el: howItWorksPagination,
        clickable: true
      }
    });
  }
}


function initializeStandaloneSwipers(scope = document) {
  const swiperContainer = scope.querySelector('.standalone-swiper');
  if (swiperContainer) {
    const swiperNavigationNext = scope.querySelector('.standalone-swiper-next');
    const swiperNavigationPrev = scope.querySelector('.standalone-swiper-prev');
    const swiperPagination = scope.querySelector('.standalone-swiper-pagination');

    new Swiper(swiperContainer, {
      slidesPerView: 1,
      spaceBetween: 16,
      navigation: {
        nextEl: swiperNavigationNext,
        prevEl: swiperNavigationPrev
      },
      pagination: {
        el: swiperPagination,
        clickable: true
      }
    });
  }
}